enum IconStyles {
    Normal = "normal",
    Red = "red",
    Green = "green",
    Blue = "blue",
    ReversedX = "reversedX",
    ReversedY = "reversedY",
}

export default IconStyles;

export type IconStyle = IconStyles.Normal | IconStyles.Red | IconStyles.Green | IconStyles.Blue | IconStyles.ReversedX | IconStyles.ReversedY;